import { render } from "./PostDraftList.vue?vue&type=template&id=1f5570b7"
import script from "./PostDraftList.vue?vue&type=script&lang=js"
export * from "./PostDraftList.vue?vue&type=script&lang=js"
script.render = render

export default script